import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";
import DtoAutoAddWharf_Pool from "./DtoAutoAddWharf_Pool";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoAutoAddWharf {
    constructor() {
        //无参构造函数
        this.Pools = [];
    }

    [proName: string]: any;
    /**
     * 订单主键
     */
    OrderId?: string;
    /**
     * 委托书主键
     */
    PoolId?: string;
    /**
     * 预计到仓时间
     */
    EstimatedAtWwarehouseDate?: Date;
    /**
     * 类型
     */
    Type?: EnumOrderServiceType;
    /**
     * 委托书主键集合
     */
    Pools?: DtoAutoAddWharf_Pool[];
}

/**
 * -表单校验
 */
export const DtoAutoAddWharfRules = {
}
